<template xmlns="http://www.w3.org/1999/html">
  <div class="openDialog">
    <el-dialog title="开通资源接口服务" custom-class="open-interface-manager-dialog" :visible.sync="openDialogVisible">
      <el-form ref="renewalForm" :model="renewalForm" :rules="rules" label-width="120px">
        <div>
          <el-form-item label="开通类型"  class="is-required">
            <el-radio-group v-model="renewalForm.type">
              <el-radio-button label="1">按时间</el-radio-button>
              <el-radio-button label="2">按数量</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div label="按时段" v-if="renewalForm.type == 1">
            <el-form-item label="开通时段"  class="is-required" prop="openData">
              <el-date-picker type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                v-model="renewalForm.openData"
                style="width: 100%;"
                range-separator="-"
                value-format="yyyy-MM-dd"
                :picker-options="pickerDate"
                :editable="false">
              </el-date-picker>
            </el-form-item>
          </div>
          <div label="按数量" v-if="renewalForm.type == 2">
            <el-form-item label="接口调用上限"  class="is-required" prop="invoke">
              <el-input v-model.number="renewalForm.invoke" :disabled="renewalData.apiResourceDto.id == 1"></el-input>
            </el-form-item>
            <el-form-item label="去重下载上限"  class="is-required" prop="download">
              <el-input v-model.number="renewalForm.download" :disabled="renewalData.apiResourceDto.id == 1"></el-input>
            </el-form-item>

          </div>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="openit()" v-loading="loading">开通</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
export default {
  props: {
    renewalData: {
      type: Object
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    let validateData = (rule, value, callback) => {
      if (this.renewalForm.type == '1') {
        if (!value) {
          callback(new Error('请选择时段'))
        }
      }
      callback()
    }

    let validateInvokeLimit = (rule, value, callback) => {
      if (this.renewalForm.type == '2' && this.renewalData.apiResourceDto.id != 1) {
        if (value === '') {
          callback(new Error('请输入接口数量'))
        } else if (value <= 0) {
          callback(new Error('开通接口数量必须大于0'))
        }
      }
      callback()
    }

    let validateDownloadLimit = (rule, value, callback) => {
      if (this.renewalForm.type == '2' && this.renewalData.apiResourceDto.id != 1) {
        if (value === '') {
          callback(new Error('请输入接口数量'))
        } else if (value <= 0) {
          callback(new Error('开通接口数量必须大于0'))
        }
      }
      callback()
    }

    return {
      loading: false,
      rules: {
        openData: [
          {validator: validateData, trigger: ['blur', 'change']}
        ],
        invoke: [
          {validator: validateInvokeLimit, trigger: ['blur', 'change']}
        ],
        download: [
          {validator: validateDownloadLimit, trigger: ['blur', 'change']}
        ]
      },
      pickerDate: {
        disabledDate: time => {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000
        }
      },
      renewalForm: {
        type: '2',
        openData: '',
        invoke: '',
        download: ''
      }
    }
  },
  methods: {
    openit () {
      this.loading = true
      this.$refs.renewalForm.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            // this.renewalData.userId = this.id
            if (this.renewalForm.openData) {
              this.renewalForm.startTime = this.renewalForm.openData[0]
              this.renewalForm.endTime = this.renewalForm.openData[1]
            }
            if (this.renewalData.apiResourceDto.id == 1) {
              this.renewalForm.download = -1
              this.renewalForm.invoke = -1
            }
            await devService.openDev({
              type: this.renewalForm.type,
              status: 2,
              startTime: this.renewalForm.startTime,
              endTime: this.renewalForm.endTime,
              userId: this.renewalData.userId,
              invokeLimit: this.renewalForm.invoke,
              downloadLimit: this.renewalForm.download,
              resourceId: this.renewalData.apiResourceDto.id
            })
            this.$message.success(this.SysConstant.success)
            this.$emit('success')
            this.openDialogVisible = false
          } catch (e) {
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    }
  },
  watch: {
    openDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.renewalForm) {
          this.$refs.renewalForm.resetFields()
          this.renewalForm.openData = ''
          this.renewalForm.invoke = ''
          this.renewalForm.download = ''
        }
      }
    }
  },
  computed: {
    openDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

  .openDialog .open-interface-manager-dialog{
    width: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/admin/interface-manage/open-dialog/index.vue